import { render, staticRenderFns } from "./LibroBancarioPage.vue?vue&type=template&id=10dec882"
import script from "./LibroBancarioPage.js?vue&type=script&lang=js&external"
export * from "./LibroBancarioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports